// import { isString } from 'lodash';

export const STAGING_SITE_URL = 'http://192.168.20.10:8001';
export const LIVE_SITE_URL = 'https://portal.buildformula.com';

export const BASE_API_URL = `${process.env.REACT_APP_SERVER_URL}/api/`;

export const LIVE_REDIRECT = 'https://portal.buildformula.com/';
export const STAGING_REDIRECT = 'http://192.168.20.10:8001';

export const PHONE_REGEX =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export const HTML_REGEX = /(<([^>]+)>)/gi;
export const DECIMAL_REGEX = /^\d+(\.\d{1,2})?$/;
export const ADHAAR_REGEX = /\d{4}-\d{4}-\d{4}/i;
export const ELECTION_REGEX = /^[A-Za-z]{3}[0-9]{7}$/;
export const DRIVING_REGEX = /^[A-Za-z]{2}[0-9]{2} [0-9]{11}$/;

export const PAN_REGEX =
  /^([a-zA-Z]([a-zA-Z]([a-zA-Z]([a-zA-Z]([a-zA-Z]([0-9]([0-9]([0-9]([0-9]([a-zA-Z])?)?)?)?)?)?)?)?)?)?$/;
export const PASSPORT_REGEX = /^[A-Za-z]\d{7}$/;
export const GST_REGEX = /[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[1-9A-Z]{1}$/;

export const MAX_TOWERS = 26;
export const MAX_FLOORS = 100;
export const MAX_UNITS = { 1: 99, 2: 99, 3: 99, 4: 1000, 5: 1000 };
export const MAX_BUNGALOW_UNITS = 99;

export const DEFAULT_STRUCTURE = {
  1: { towerCount: undefined, towers: {} },
  2: { towerCount: undefined, towers: {} },
  3: { towerCount: undefined, towers: {} },
  4: { unitCount: undefined, units: {} },
  5: { unitCount: undefined, units: {} },
};

export const STRUCTURE_TYPE_LABELS = {
  2: 'Shops',
  3: 'Offices',
  1: 'Apartments',
  4: 'Bungalows',
  5: 'Plots',
};

export const GLOBAL_STATUS = {
  pending: { label: 'Pending', color: '#F4AF48' },
  approved: { label: 'Approved', color: '#07CA03' },
  rejected: { label: 'Rejected', color: '#FF5D5D' },
  deleted: { label: 'Deleted', color: '#4872f4' },
};

export const BHK_OPTIONS = [
  { type: 1, color: 'rgba(244,175,72)' },
  { type: 2, color: 'rgba(134, 134, 134)' },
  { type: 3, color: 'rgba(72, 161, 244)' },
  { type: 4, color: 'rgba(149, 100, 100)' },
  { type: 5, color: 'rgba(168, 72, 244)' },
  { type: 6, color: 'rgba(0, 205, 205)' },
  { type: 7, color: 'rgba(99, 149, 104)' },
];

export const DOCUMENT_CHARGE_LIMIT = 20000;

export const MODIFY_REQUEST_STATUS = {
  pending: { label: 'PENDING APPROVAL', color: '#F4AF48' },
  approved: { label: 'APPROVED', color: '#07CA03' },
  rejected: { label: 'REJECTED', color: '#FF5D5D' },
  cancel_by_customer: { label: 'CANCEL BY CUSTOMER', color: '#041D36' },
  confirmed_by_customer: { label: 'CONFIRMED BY CUSTOMER', color: '#041D36' },
};

export const PR_REQUEST_STATUS = {
  1: { label: 'Pending', color: '#F4AF48' },
  2: { label: 'Approved', color: '#07CA03' },
  3: { label: 'Rejected', color: '#FF5D5D' },
};

export const CN_STATUS = {
  1: { label: 'Open', color: '#07CA03' },
  2: { label: 'Closed', color: '#FF5D5D' },
};

export const PR_REQUEST_DETAILS_STATUS = {
  1: {
    label: 'PR Approved',
    color: '#07CA03',
    icon: 'check-circle',
    2: { label: 'Rejected PR', color: '#FF5D5D', icon: 'cancel' },
  },
};
export const STORE_KEEPER_STATUS = {
  pending: { label: 'Pending', color: '#F4AF48' },
  approved: { label: 'Approved', color: '#07CA03' },
  issued: { label: 'Issued', color: '#07CA03', icon: 'storefront-outline' },
  inspected: { label: 'Inspected', color: '#07CA03' },
};

export const STORE_KEEPER_DETAILS_STATUS = {
  1: { label: 'Approved', color: '#4872F4' },
  2: { label: 'Rejected', color: '#FF5D5D' },
};

export const STRUCTURE_TYPE = { PLOT: 5, BUNGALOW: 4 };

export const DEFAULT_ADMIN_PERMISSIONS = {
  admin: 1,
  approval: 1,
  editor: 1,
  view: 1,
  none: 0,
};

export function getFileName(string) {
  if (string?.includes('/')) {
    const splits = string?.split('/');
    return splits[splits.length - 1];
  }

  return string;
}

export const rowsPerPage = 50;

export const DEFAULT_PROJECT_FILTERS = {
  projectNames: '',
  developerNames: '',
  area: '',
  status: '',
  premium: '',
  possession: '',
  rera: '',
  projectType: '',
  restrictedUser: '',
  projectStatus: '',
  projectQuality: '',
  bhk: '',
  category: '',
  towers: '',
  units: '',
  bungalows: '',
  plots: '',
  owners: '',
  security: '',
};

export function getUniqueOptions(options) {
  const uniqueData = options?.filter((obj, index) => {
    return index === options?.findIndex(o => obj.label === o.label || obj.value === o.value);
  });

  return uniqueData;
}

export function validateDecimals(
  key: string,
  fieldValue: any,
  set: (key: string, value: number) => void,
) {
  const { valueAsNumber = 0 } = fieldValue.target;

  const value = isNaN(valueAsNumber) || valueAsNumber < 0 ? 0 : valueAsNumber;

  if (DECIMAL_REGEX.test(String(value)) || value === 0) {
    set(key, valueAsNumber);
  }
}

export function processError(error: any) {
  if (error?.data?.msg && typeof error?.data?.msg === 'object') {
    const result = Object?.values(error?.data?.msg).join(', ');
    return result;
  }

  return error?.data?.msg || 'An error occurred. Please try again.';
}

export const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'June',
  'July',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'Dec',
];

export const DISTRIBUTION_METHOD = [
  'Equally with all installments',
  'Proportionately with all installment',
  // 'Proportionately with all installment(Except First)',
  'Connect with last installment',
  'Dont connect with installment',
];

export const OWNERSHIP_DOCUMENTS_TYPE = [
  'Election Card',
  'Aadhar Card',
  'Driving License',
  'Passport',
];

export const PERMISSIONS_BASE_STRUCTURE = {
  admin: 0,
  approval: 0,
  editor: 0,
  view: 0,
  none: 0,
  add: 0,
};

export const DEFAULT_BOOKING_APPROVAL_FILTERS = {
  status: '',
  evaluated_by: '',
};
export const DEFAULT_CONSTRUCTION_FILTERS = {
  duration: '0', // 0 daily | 1 m | weekly | month number
  progress_status: '', // in-progress, delayed, completed
  label_id: 0,
  work_id: 0,
  assignee: [],
  fromDate: '',
  toDate: '',
};
export const DEFAULT_USER_FILTER = {
  user_id: '',
};
